import { engagementApiSuppressionLists } from "@dashboardApi/apis/engagementApiSuppressionLists";
import { engagementApiSuppressionListsId } from "@dashboardApi/apis/engagementApiSuppressionListsId";
import { engagementSegmentData } from "@dashboardApi/apis/engagementSegmentData";
import { engagementSegments } from "@dashboardApi/apis/engagementSegments";

import type { AllRouteEndpoints } from "../routeTypes";

export const engagementSegmentsMarkAsUnarchivedCacheKeys: AllRouteEndpoints[] = [
  engagementSegments,
  engagementSegmentData,
  engagementApiSuppressionLists,
  engagementApiSuppressionListsId,
];
